export const AiIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_12288_5781)">
        <path
          d="M15.5986 5C16.1868 9.51299 19.3904 13.2035 23.6396 14.5C19.7087 15.6994 16.6731 18.9473 15.7744 23H15.2256C14.3376 18.9957 11.3628 15.779 7.5 14.5459V14.4531C11.6793 13.1188 14.8197 9.46309 15.4014 5H15.5986Z"
          fill="white"
        />
        <path
          d="M5.99902 3.00098C6.79173 4.90045 8.4605 6.34303 10.5 6.8252V7.1748C8.46075 7.65661 6.79196 9.09815 5.99902 10.9971C5.2059 9.09833 3.5389 7.65555 1.5 7.17383V6.8252C3.53917 6.34304 5.20621 4.90036 5.99902 3.00098Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_12288_5781">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
